import React from "react";

interface IExpressInfoCard{
    icon: JSX.Element;
    titleText: string;
    description: string;
    isComingSoon?: boolean;
    iconBackgroundColor?: "primary" | "secondary"
}

const ExpressInfoCard = ({
  icon,
  titleText,
  description,
  isComingSoon = false,
  iconBackgroundColor = "secondary",
}: IExpressInfoCard) => {
  return (
    <div className="border border-taupe-50 flex gap-2 bg-white
      rounded-lg p-4">
      <div className={`flex items-center justify-center
        ${iconBackgroundColor === "primary" ? "bg-taupe-4" : "bg-taupe-5"} rounded-full p-2 h-fit`}>
        {icon}
      </div>
      <div className="flex flex-col gap-1.5">
        <div className="flex gap-3 font-semibold">
          {titleText}
          {isComingSoon &&
          <div className="!font-normal text-xs p-1 bg-gv-yellow-light text-gv-gold rounded-lg">
            Coming Soon
          </div>}
        </div>
        <div className="text-xs text-gray-1">{description}</div>
      </div>
    </div>
  );
};

export default ExpressInfoCard;
